<template>
  <div class="develop">
    <div class="develop-upper com-padding-top-90 com-padding-bottom-50">
      <div class="com-content-1340 com-content">
        <div class="dn-lower">
          <div class="swiper-container swiper1">
            <div class="swiper-wrapper wrapper1">
              <div class="swiper-slide slide1"
                   v-for="(item, index) in dataData" :key="index">
                <div class="dp-cont">
                  <div class="dp-time1">{{ item.val_one }}</div>
                  <div class="dp-ti1">{{ item.title }}</div>
                  <img :src="stateimgBaseURL+item.imga_path"
                       alt="" class="dp-img1 com-object-fit-cover">
                  <div class="dp-intr1" v-html="item.recom"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  data() {
    return {
      dataData: [],
    }
  },
  computed: {
    ...mapState(['stateimgBaseURL'])
  },
  created() {
    this.dataRequestbrandstore_developHistory()
  },
  methods: {
    // GET发展历程
    dataRequestbrandstore_developHistory() {
      this.$api.user.brandstore_developHistory().then(res => {
        this.dataData = res.data.list
      })
    },
  }
}
</script>

<style scoped lang="scss">
.develop {
  .dn-lower {
    .swiper1 {
      &:before {
        content: '';
        position: absolute;
        left: 50%;
        top: 0;
        width: 2px;
        height: 100%;
        background: $line1;
      }

      .wrapper1 {
        flex-wrap: wrap;
      }

      .slide1 {
        display: flex;
        justify-content: space-between;

        &:nth-of-type(even) {
          flex-direction: row-reverse;
          text-align: right;
        }

        .dp-cont {
          width: 50%;
          position: relative;
          padding: 0 5%;

          &:before {
            content: '';
            position: absolute;
            left: 0;
            top: 36px;
            width: 100%;
            height: 1px;
            background: $line1;
          }

          .dp-time1 {
            font-size: 30px;
            color: #333333;
          }

          .dp-ti1 {
            font-size: 18px;
            margin: 10px 0 10px;
          }

          .dp-img1 {
            width: 200px;
            height: 100px;
          }

          .dp-intr1 {
            margin: 10px 0 0;
            line-height: 24px;
          }

        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .develop {
    .dn-lower {
      .swiper1 {
        &:before {
          display: none;
        }


        .slide1 {
          padding: 20*$mobile-conversion 0;

          .dp-cont {
            width: 100%;
            padding: 0 !important;

            &:before {
              top: 45*$mobile-conversion;
            }

            .dp-time1 {
              font-size: 36*$mobile-conversion;
            }

            .dp-ti1 {
              font-size: 28*$mobile-conversion;
              margin: 10*$mobile-conversion 0;
            }

            .dp-img1 {
              width: 200*$mobile-conversion;
              height: 100*$mobile-conversion;
            }

            .dp-intr1 {
              margin: 10*$mobile-conversion 0 0;
              line-height: 40*$mobile-conversion;
            }

          }
        }
      }
    }
  }
}
</style>
